import React from 'react';

const Package = () => (
  <svg
    width="27"
    height="27"
    viewBox="0 0 27 27"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18.5625 10.575L8.4375 4.73624"
      stroke="#0F1C35"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2 7L13.5 1L25 7V20L13.5 26L2 20V7Z"
      stroke="#0F1C35"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.67871 7.82999L13.5 13.5112L23.3212 7.82999"
      stroke="#0F1C35"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.5 24.84V13.5"
      stroke="#0F1C35"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default Package;
